import { useHudContext } from "../../hud/shared/playbookHUDInfra"
import { deriveAgentDataForYear } from "./computeDerivedAgents"
import { useLaborMixYear } from "./useLaborMixYear"

export type AiSpeedBreakdown = {
  // Copies on each hardware tier: the bulk on general hardware at the
  // typical speed, and the small fleet on inference-specialized hardware
  // running "up to" fast.
  countGeneral: number
  countSpecialized: number
  // Human-relative speed multipliers (human = 10 tok/s), rounded.
  generalMultiplier: number
  specializedMultiplier: number
}

// How many AIs run at which speed, at the HUD's current date — the two
// counts behind the legend's "at up to ×N speed". Null when the split isn't
// defined: branch phases carry a single blended speed, and the sheet retires
// the specialized fleet after 2040.
export const useAiSpeedBreakdown = (): AiSpeedBreakdown | null => {
  const year = useLaborMixYear()
  const currentPhase = useHudContext().currentPhase
  const onBranch = currentPhase?.aiCopies !== undefined || currentPhase?.aiSpeedTokS !== undefined
  if (onBranch) return null
  const agent = deriveAgentDataForYear(year)
  if (agent.speedSpecialized === null || agent.copiesSpecialized <= 0 || agent.copies <= 0) {
    return null
  }
  return {
    countGeneral: agent.copies,
    countSpecialized: agent.copiesSpecialized,
    generalMultiplier: Math.round(agent.speed / 10),
    specializedMultiplier: Math.round(agent.speedSpecialized / 10),
  }
}
